import styled from 'styled-components';

const Select = styled.select`
  line-height: 1em;
  height: 20px;
`;

export default Select;



// WEBPACK FOOTER //
// ./app/components/Toggle/Select.js